<template>
  <div class="pay-notify-card-component">
    <card :title="title"
          icon="round-tick"
    >
      <div class="info-container"
           v-if="desc || subTitle"
      >
        <div class="notify-desc">{{ desc }}</div>
        <div class="sub-title">{{ subTitle }}</div>
        <div class="product-list"
             v-if="product.length !== 0"
        >
          <div class="product-item"
               v-for="(item, index) in product"
               :key="index"
          >
            · {{ item }}
          </div>
        </div>
        <div class="time-desc"
             v-if="timeDesc !== ''"
        >
          {{ timeDesc }}
        </div>
      </div>
      <slot></slot>
      <qr-code-block class="qr-code-block"
                     :qrCode="qrCode"
                     :hide-qr-code-name="hideQrCodeName"
                     v-if="qrCode"
      />
      <div class="mobile-block"
           v-if="qrCode && showMobile"
      >
        如无法添加，可拨打<a class="mobile-link" :href="consumerHotLineHref">{{ consumerHotLine }}</a>联系我们
      </div>
      <router-link class="link"
                   :to="route"
                   v-if="linkText"
      >
        {{ linkText }}
      </router-link>
    </card>
  </div>
</template>

<script>
  import Card from '@/components/Card';
  import QrCodeBlock from '@/components/ServiceQrCode/Block';
  import validator from '@/utils/validator';
  import { CONSUMER_HOTLINE } from '@/utils/constant';

  export default {
    name: 'PayNotifyCard',
    components: {
      Card,
      QrCodeBlock,
    },
    props: {
      title: {
        type: String,
        default: '支付成功',
      },
      desc: {
        type: String,
      },
      subTitle: {
        type: String,
        default: '',
      },
      timeDesc: {
        type: String,
        default: '',
      },
      qrCode: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      route: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      linkText: {
        type: String,
      },
      showMobile: {
        type: Boolean,
        default: false,
      },
      hideQrCodeName: {
        type: Boolean,
      },
      multiDesc: {
        type: String,
        default: '',
      },
      product: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      consumerHotLine() {
        return CONSUMER_HOTLINE;
      },
      consumerHotLineHref() {
        return `tel:${CONSUMER_HOTLINE}`;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-notify-card-component {
    min-height: 100%;
    background-color: @background-color-base;
    padding: @size-base;
    box-sizing: border-box;
  }

  .info-container {
    line-height: 1;
    margin-bottom: @size-extra-medium;
  }

  .notify-desc {
    margin-bottom: @size-small;
    font-size: @font-size-medium;
  }

  .sub-title {
    width: 560px;
    margin: 0 auto;
    font-size: @font-size-large;
    line-height: 1.4;
    font-weight: @font-weight-primary;
  }

  .product-list {
    font-size: @font-size-large;
    font-weight: @font-weight-bold;
    line-height: 1.4;
    color: @color-text-base;
  }

  .time-desc {
    margin-top: @size-small;
    font-size: @font-size-base;
    color: @color-text-base;
  }

  .mobile-block {
    margin-top: @size-medium;
    font-size: @size-base;
    color: @color-text-lighter;
  }

  .mobile-link {
    color: @color-link;
  }

  .link {
    display: block;
    margin-top: @size-extra-medium;
    padding-top: @size-medium;
    border-top: @border-base;
    color: @color-link;
    font-size: @font-size-medium;
    line-height: 1;
  }
</style>
